import { Nullable } from '@clearverify/types';

import { EmployerStaffWhere, UserStatus } from 'src/api';

type EmployerStaffTableFilter = {
  status?: Nullable<UserStatus[]>;
};

export const prepareEmployerStaffFilter = (
  filter: EmployerStaffTableFilter,
): EmployerStaffWhere => {
  const statusFilter: EmployerStaffWhere =
    filter.status && filter.status.length > 0
      ? {
          user: {
            status: {
              in: filter.status,
            },
          },
        }
      : {};

  return statusFilter;
};
